var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoosterGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    fill: "url(#myGradientID)",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.65 90",
    height: "100px",
    width: "100px",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "myGradientID",
    gradientTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#926F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#FAF398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#E0AA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9F295"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.39,2.05c6.83-3.08,13.57-2.39,18.61.11l.28,3.17,3.84-.4c1.59,1.43,2.81,3.07,3.51,4.79,2.35,5.71-.76,11.42-5,15.47-.38.36-10.11-.25-10.15-.52-.49-3.42-2.88-5.57-5.88-4.87-3.38.79-2.79,4.94-1.36,6.41.23.23-8.06-.22-10.85-6.04-2.25-4.69-1.97-14.08,7-18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.44,19.69c.52-4.27.95-9.61-1.73-13.33-2.19-3.04-6.11-3.79-9.79-3.18,1.1-.38,2.28-.59,3.47-.67,2.46-.17,5.13.02,7.36,1.13,2.41,1.21,3.85,3.64,4.51,6.13,1.34,5.12-.3,10.56-1.78,15.49-.91-.03-1.92-.09-2.87-.15.31-1.8.62-3.6.84-5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.16,48.1c2.21,1.43,5.56-.46,6.54-2.38,1.33-2.62-.43-4.71-2.04-6.77-1.21-1.55-3-5.38-2.87-7.24,0-.33-2.97,6.52-3.29,9.05-.59,4.62.59,6.63,1.66,7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,19.79c-3.12.73-2.85,4.3-1.66,6-.56-.33-1.07-.73-1.54-1.14-.88-.79-1.73-1.68-2.17-2.75-.66-1.61-.49-3.44.59-4.87,1.2-1.58,3.36-2.26,5.4-2.1,2.23.17,4.34,1.29,5.25,3.2.88,1.85,1.16,4.37.18,6.23-.06.11-.09.22-.09.33-.04-.01-.08-.03-.08-.04-.49-3.42-2.88-5.57-5.88-4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,23.91c15.49.59,15.34,17.33,21.65,21.4,1.86,1.2,4.89.87,6.34-.88,1.02-1.24,1.12-2.89,1.17-4.38.1-3.14,0-6.28.07-9.42.06-2.7.36-5.69,2.63-7.67,1.85-1.61,4.38-2.29,7.07-1.36,2.63.91,3.92,2.58,4.11,4.76.12,1.41-.5,2.86-.91,4.2l-1.64,5.37c-.42,2.66-.44,5.35,0,8.02.77,4.58,2.34,9.06,2.18,13.76-.34,10-7.09,15.78-14.55,17.37h-8.46c-1.54-.34-3.03-.85-4.38-1.57-7.74-4.12-6.88-15.18-7.65-21.41-.33-2.72-1.33-5.77-4.27-7.04-2.84-1.23-6.28-.48-8.61,1.29-3.76,2.87-5.81,8.43-4.08,12.72.41,1-.6,2.04-1.69,1.63-15.06-5.66-14.42-37.75,11-36.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.66,
    y: 75.07,
    width: 8.46,
    height: 6.1,
    transform: "translate(89.78 156.23) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.82 90 52.96 90 52.96 85.58 49.12 81.17 40.66 81.17 36.82 85.58 36.82 90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.75,28.68l7.91-1.71-7.83-1.8c-1.08,1.46-.08,3.51-.08,3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.99,25.51c0,.44.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.14,73.19c.26.33.78.54,1.2.29,8.49-5.15,23.9-11.29,15.65-29.05,0,0-4.37,4.12-8.41-1.13,0,0-5.28,4.5-8.99,11.94-1.3,2.61-1.88,6.05-1.98,8.87-.1,3.05.5,6.54,2.53,9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.82,42.85c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.57,39.23c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.88,36.06c.45-.07.76-.49.68-.93-.08-.44-.5-.74-.95-.66-.45.07-.76.49-.68.93.08.44.5.74.95.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.55,31.34c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.64,28.04c.14-.42-.09-.88-.52-1.02-.43-.14-.9.08-1.05.51-.15.42.09.88.52,1.02.43.14.9-.08,1.05-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.16,26.02c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.08,26.02c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.32,27.06c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28,29.39c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49,32.8c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52,36.73c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69,41.15c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21,46.08c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21,51.03c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4,55.29c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,58.4c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.76,46.08c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.95,42.04c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.93,38.03c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.49,33.6c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.82,30.2c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.74,29.19c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.42,30.8c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.05,34.41c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41,39.15c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39,44.11c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78,49.41c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8,48.12c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7,47.7c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.53,51.83c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.53,56.4c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.44,60.96c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.98,64.25c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.77,67.29c0,.45.37.81.83.81s.83-.36.83-.81c0-.45-.37-.81-.83-.81s-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.33,
    cy: 69.95,
    rx: 0.83,
    ry: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46,51.83c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.99,55.9c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.89,59.5c0,.44.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.77,62.32c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.05,64.56c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.95,48.93c0,.44.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.72,52.87c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1,45.72c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.03,41.15c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.65,36.73c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.94,33.21c0,.45.37.81.83.81s.83-.36.83-.81c0-.45-.37-.81-.83-.81s-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.03,34.02c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.42,38.18c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1,43.15c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4,42.22c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.74,37.87c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.09,37.98c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.46,42.22c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.64,46.08c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.48,49.31c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.83,53.68c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.94,57.2c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5,60.16c0,.45.37.81.83.81s.83-.36.83-.81c0-.44-.37-.81-.83-.81s-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.26,67.35c.24.38.76.49,1.14.25.39-.24.5-.74.26-1.11-.24-.38-.76-.49-1.14-.25s-.5.74-.26,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.94,69.54c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.05,71.57c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.96,72.78c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6,72.37c0,.45.37.81.83.81s.83-.36.83-.81-.37-.81-.83-.81-.83.36-.83.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.66,
    y: 75.07,
    width: 3.87,
    height: 6.1,
    transform: "translate(85.18 156.23) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.66 81.17 44.5 81.17 40.66 85.58 40.66 90 36.82 90 36.82 85.58 40.66 81.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.08,27.34c.14.83-1.04,1.15-1.79,2.64-1.01,2.03-.04,3.91-.46,4.04-.46.14-2.06-1.95-2.02-4.38,0-.3.09-3.16,1.73-3.59,1.02-.27,2.4.46,2.54,1.29Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoosterGold);
export default __webpack_public_path__ + "static/media/Rooster-Gold.4f4181a6.svg";
export { ForwardRef as ReactComponent };